import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TipoProcessoComponent } from './modules/module-app/components/configuracoes/tipo-processo/tipo-processo.component';
import { LoginComponent } from './modules/module-app/components/login/login.component';
import { MenuLateralComponent } from './modules/module-app/components/dashboard/menu-lateral/menu-lateral.component';
import { NivelServicoComponent } from './modules/module-app/components/configuracoes/nivel-servico/nivel-servico.component';
import { MonitorProcessosComponent } from './modules/module-app/components/dashboard/monitor-processos/monitor-processos.component';
import { UploadDocumentosComponent } from './modules/module-app/components/upload-documentos/upload-documentos.component';
import { CadastroPoderesComponent } from './modules/module-app/components/cadastro-poderes/cadastro-poderes.component';
import { FeitoConferidoComponent } from './modules/module-app/components/feito-conferido/feito-conferido.component';
import { CadastroPoderesClienteComponent } from './modules/module-app/components/cadastro-poderes/cadastro-poderes-cliente/cadastro-poderes-cliente.component';
import { CadastroPoderesInternosComponent } from './modules/module-app/components/cadastro-poderes-internos/cadastro-poderes-internos.component';
import { AssinaturaInternaComponent } from './modules/module-app/components/assinatura-interna/assinatura-interna/assinatura-interna.component';
import { ControleDocumentosComponent } from './modules/module-app/components/dashboard-documentos/controle-documentos/controle-documentos.component';
import { BlankComponent } from './modules/module-app/components/blank/blank.component';
import { ClienteSemAutorizadorComponent } from './modules/module-app/components/cliente-sem-autorizador/cliente-sem-autorizador.component';

const routes: Routes = [
  //{ path: "", redirectTo:"", pathMatch:"full"},
  { path: "", component: LoginComponent },
  { path: "monitor-processos", component: MonitorProcessosComponent },
  { path: "blank", component: BlankComponent},
  { path: "controle-docs", component: ControleDocumentosComponent},
  { path: "cadastro-poderes", component: CadastroPoderesComponent }, 
  { path: "cadastro-poderes-cliente/:cliente", component: CadastroPoderesClienteComponent }, 
  { path: "cadastro-poderes-internos", component: CadastroPoderesInternosComponent }, 
  { path: "cliente-sem", component: ClienteSemAutorizadorComponent }, 
  { path: "upload-contratos", component: UploadDocumentosComponent },
  { path: "assinatura-interna", component: AssinaturaInternaComponent },
  { path: "feito-conferido", component: FeitoConferidoComponent },
  { path: "tipo-processo", component: TipoProcessoComponent },
  { path: "nivel-risco", component: NivelServicoComponent },
  { path: "menus", component: MenuLateralComponent, outlet: "sidebar" },
  { path: "**", redirectTo:""}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
